import { Typography } from "@material-ui/core";

export default function GenericCardHeader(props) {
  const {
    style,
    onClose,
    title,
    leftComponent: LeftComponent,
    rightComponent: RightComponent,
    ...rest
  } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        justifyItems: "center",
        height: "var(--hse-line-height)",
        ...style,
      }}
      {...rest}
    >
      <LeftComponent />
      <div style={{ flexGrow: 1 }}>
        <Typography variant="h3">{title}</Typography>
      </div>
      <RightComponent />
    </div>
  );
}
